import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTransformOptions } from 'Core/hooks';
import { TextEditor } from 'Core/components/editor';
import CustomPropTypes from 'CustomPropTypes';
// import { fetchStatuses } from '../../core/redux/status/slice';
// import { fetchLabels } from '../../core/redux/label/slice';

const initData = {
  assetNumber:"",
  brand:"",
  cellNumber:"",
  changed:"",
  id:0,
  isDeleted:"",
  lane:"",
  modelNumber:"",
  moldheightMax:"",
  moldheightMin:"",
  numberofAirBlows:"",
  numberofCores:"",
  numberofValveGates:"",
  serialNumber:"",
  shotsize:"",
  tieBarDistanceH:"",
  tieBarDistanceV:"",
  tonnage:"",
  userId:"",
};

const MachinesAddEditForm = ({ data, onChanges, id }) => {

  const [formData, setFormData] = useState(data ? data : initData);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
    onChanges({ ...formData, [fieldName]: value });
  };

  const expeditedList = [
    { value: 'No', label: 'No' },
    { value: 'Yes', label: 'Yes' },
  ];

  return (
    <>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Asset Number <span className="text-danger">*</span>
            </label>
            <input
              name="assetNumber"
              type="text"
              className="form-control"
              value={formData.assetNumber}
              onChange={e => updateFormField('assetNumber', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Cell Number <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.cellNumber}
                onChange={e => updateFormField('cellNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Brand <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.brand}
                onChange={e => updateFormField('brand', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Model Number <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.modelNumber}
                onChange={e => updateFormField('modelNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tonnage <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.tonnage}
                onChange={e => updateFormField('tonnage', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Short Size (oz) <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.shotsize}
                onChange={e => updateFormField('shotsize', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Tie Bar Distance (Horizontal) <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.tieBarDistanceH}
                onChange={e => updateFormField('tieBarDistanceH', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
            Tie Bar Distance (Vertical) <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.tieBarDistanceV}
                onChange={e => updateFormField('tieBarDistanceV', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Mold Height Minimum <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.moldheightMin}
                onChange={e => updateFormField('moldheightMin', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
            Mold Height Maximum <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.moldheightMax}
                onChange={e => updateFormField('moldheightMax', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Serial Number <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.serialNumber}
                onChange={e => updateFormField('serialNumber', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
            Number of Cores <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.numberofCores}
                onChange={e => updateFormField('numberofCores', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Number of Valve Gates <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.numberofValveGates}
                onChange={e => updateFormField('numberofValveGates', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
            Number of Air Blows <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.numberofAirBlows}
                onChange={e => updateFormField('numberofAirBlows', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Lane <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.lane}
                onChange={e => updateFormField('lane', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

MachinesAddEditForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape(CustomPropTypes.machines),
  onChanges: PropTypes.func,
};

export default MachinesAddEditForm;
